/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/022-dice': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.5 3h-8A2.507 2.507 0 003 5.5v8C3 14.875 4.125 16 5.5 16h8c1.375 0 2.5-1.125 2.5-2.5v-8C16 4.125 14.875 3 13.5 3zm-7 11a1.5 1.5 0 11.001-3.001A1.5 1.5 0 016.5 14zm0-6a1.5 1.5 0 11.001-3.001A1.5 1.5 0 016.5 8zm3 3a1.5 1.5 0 11.001-3.001A1.5 1.5 0 019.5 11zm3 3a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0112.5 14zm0-6a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0112.5 8zm.449-6A2.509 2.509 0 0010.5 0h-8A2.507 2.507 0 000 2.5v8c0 1.204.862 2.216 2 2.449V3c0-.55.45-1 1-1h9.949z"/>'
  }
})
